import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Action from './Modules.Action.record';
import { Field } from 'kts-scaffold-framework/utils/doc';
import Filter from './UI.AuthRecord.Filter';
import RecordModal from './UI.AuthRecord.Modal';
import PageUi from 'kts-platform-frame/display/components/PageUi';
import moment from 'moment';
import InfiniteScroll from 'kts-scaffold-framework/component/InfiniteScroll';
import { Table, Tag, Button, Icon } from 'antd';
import { authManage } from '../../../api';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    random?: number;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthRecord extends UIBasic<IProps, ModulesState> {
    public scroller: InfiniteScroll;
    public columns = [
        {
            title: '认证税期',
            dataIndex: 'invoicePeriod',
            className: 'text-center ant-td-status',
            width: 120,
            render: (text, record) => {
                return (
                    <div className="text-center">
                        {text}
                    </div>
                );
            }
        },
        {
            title: '备注信息',
            dataIndex: 'batchNote',
            width: 150,
            render: (text) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: '金额',
            dataIndex: 'batchamountWithoutTax',
            width: 100,
            className: 'text-center',
            render: (text) => {
                return <span> {text !== '' ? ('¥' + Field.formatMoney(text, 2)) : '——'} </span>;
            }
        },

        {
            title: '税额',
            dataIndex: 'batchamountTax',
            width: 100,
            className: 'text-center',
            render: (text, record) => {
                return <span>{text !== '' ? ('¥' + Field.formatMoney(text, 2)) : '——'}</span>;
            }
        },
        {
            title: '认证状态',
            dataIndex: 'authEndFlag',
            className: 'text-center',
            width: 90,
            render: (text, record) => {
                return (
                    <div>
                        {text === 1 && (
                            <Tag color="orange">认证中</Tag>
                        )}
                        {text === 2 && (
                            <Tag color="green">处理完毕</Tag>
                        )}
                    </div>
                );
            }
        },
        {
            title: '认证类型',
            dataIndex: 'authType',
            className: 'text-center',
            width: 90,
            render: (text, record) => {
                return (
                    <div>
                        {
                            text === 1 &&
                            <span>抵扣</span>
                        }
                        {
                            text === 2 &&
                            <span>退税</span>
                        }
                    </div>
                );
            }
        },
        {
            title: '结果',
            className: 'text-center',
            width: 125,
            render: (text, record) => (
                <div>
                    {
                        record.authEndFlag === 2 &&
                        <span>成功:<span style={{ 'color': 'red' }}>{record.batchSuccessNum}</span>张,失败:<span style={{ 'color': 'red' }}>{record.batchFailNum}</span>张</span>
                    }
                </div>
            )
        },
        {
            title: '提交时间',
            dataIndex: 'createTime',
            width: 150,
            className: 'text-center',
            render: (text, record) => {
                return (
                    <div className="text-center input-time">
                        {moment(text).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                );
            }
        },

        {
            title: '操作',
            dataIndex: 'operation',
            className: 'text-center',
            width: 70,
            render: (text, record) => {
                return (
                    <div>
                        {
                            //Lib.Util.UI.menuToggle(this.props.api, Lib.Util.Rule.GET_invoiceauth_getInvoiceAuthLogByPage) &&
                            <span className="pd5 hand" style={{ color: '#1A91EB' }} onClick={() => { Action.onDetailHandler(record); }}>详情</span>
                        }
                    </div>
                );
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        Action.getData();
    }
    handleRefresh = () => {
        this.modulesState.record.p1.list = [];
        this.modulesState.record.p1.pageNum = 1;
        this.modulesState.record.p1.hasMore = true;
        this.modulesState.record.p1.loading = false;
        ModulesAction.setModulesState().then(() => {
            Action.getData();
        });
    }
    clearState = () => {
        this.modulesState.record.p1.list = [];
        this.modulesState.record.p1.pageNum = 1;
        this.modulesState.record.p1.hasMore = true;
        this.modulesState.record.p1.loading = false;
        ModulesAction.setModulesState();
    }
    componentWillUnmount() {
        this.clearState();
    }
    showModal = () => {
        this.modulesState.record.modal = true;
        ModulesAction.setModulesState();
    }
    onCloseModal = () => {
        this.modulesState.record.modal = false;
        ModulesAction.setModulesState();
    }

    footerDom = () => {
        const { p1 } = this.modulesState.record;
        return (<div className="text-right">
            <div className='mr10' style={{ display: 'inline-block' }}>
                <div className='bold_number'>{p1.total}</div>
                <div>认证次数合计</div>
            </div>
            <span onClick={() => { this.scroller.toTop(); }}>
                <Button icon="huidaodingbuanniu" shape="circle" size='small' style={{ color: '#99A9BF' }} />
            </span>
        </div>);
    }
    render() {
        const { p1, modal } = this.modulesState.record;
        const dataSource =
            p1.list &&
            p1.list.map((item, index) => {
                return {
                    ...item,
                    index
                };
            });
        return (
            <div style={{ height: 'calc(100% - 60px)' }}>
                <div className={`text-right ${css['invoice-card-hander']}`}>
                    <Button className="ml10" onClick={Action.toggleFilter} icon="filter">
                        筛选
                    </Button>
                    <Button className="ml10" icon="sync" onClick={this.handleRefresh}>
                    </Button>
                </div>
                <div style={{ height: 'calc(100vh - 111px)', overflow: 'auto' }}>
                    <InfiniteScroll
                        loadMore={Action.getData}
                        hasMore={!p1.loading && p1.hasMore}
                        ref={(target) => { this.scroller = target; }}
                    >
                        <Table
                            columns={this.columns}
                            dataSource={dataSource}
                            rowKey={(item, index) => item.authBatchId}
                            pagination={false}
                            bordered={true}
                            scroll={{ y: 'calc(100vh - 218px)' }}
                            footer={() => { return this.footerDom(); }}
                        />
                    </InfiniteScroll>
                </div>
                {/* {p1.list && p1.list.pageMeta && (
                    <PageUi
                        pageSize={p1.pageSize}
                        data={p1.list.pageMeta}
                        onChange={Action.mapListToPage}
                        onShowSizeChange={Action.onSizeChange}
                    />
                )} */}
                {
                    modal &&
                    <RecordModal onCloseModal={this.onCloseModal} />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthRecord.tsx